import React from 'react';
import PropTypes from 'prop-types';
import '../../LinkModal.css';

import LogoLink from '../svg/LogoLink';
import Check from '../../../svg/Check';

function LinkModal({ cancelClick, modalHasEntered }) {
  const trial = () => { window.open(`https://www.beatport.com/subscriptions?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`, `_blank`) }
  const redirect = () => { window.open(`https://stream.beatport.com/?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`, `_blank`) }
  return (
    <div className={`flexColumn cta learn-more-sub`}>
      <div className={`flexColumn modalV2 bottom-reduce`}>
        <div className={`flexColumn body`} >
          <div className={`logo center`}>
            <LogoLink />
          </div>
          <div className={`title`}>Try Beatport Streaming free for 30-days to unlock:</div>
          <div className={`flexColumn description`} >
            <div className={`flexRow`} style={{gap: 8}}>
              <Check style={{marginTop: -3}} />
              <span>Full track playback of entire catalog</span>
            </div>
            <div className={`flexRow`} style={{gap: 8}}>
              <Check style={{marginTop: -3}} />
              <span>DJ in B2B Mode with up to 3 other DJs</span>
            </div>
            <div className={`flexRow`} style={{gap: 8}}>
              <Check style={{marginTop: -3}} />
              <span>Full access to Beatport Mobile App </span>
            </div>
            <div className={`flexRow`} style={{gap: 8}}>
              <Check style={{marginTop: -3}} />
              <span style={{textAlign: `left`}}>High-quality audio streaming</span>
            </div>
          </div>
          <div className={`flexRow group-cta`}>
            <div className={`cta primary half`} onClick={trial}>Free 30-Day Trial</div>
            <div className={`cta transparent-grey half`} onClick={redirect}>Learn More</div>
            <div className={`cta cancel`} onClick={cancelClick}>No Thanks</div>
          </div>
        </div>
      </div>
    </div>
  )
}

LinkModal.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default LinkModal;
